// extracted by mini-css-extract-plugin
export default {"container":"Page_container__0msBX","marginBottomNone":"Page_marginBottomNone__uQ+7j","main":"Page_main__m40WG","noOverflow":"Page_noOverflow__hElsK"};